module.exports = __webpack_public_path__ + "media/images/masks/avatar-group-edea3b7af490bda21fcdf913d51e305f.svg";